import Axios from "@/plugins/Axios";

export class DesenvolvimentoBibliotecaService {
  async buscarMatriculas(query = null) {
    const response = await Axios().get("desenvolvimento-biblioteca/matriculas", {
      params: { query },
    });

    return response.data;
  }

  async find(matriculaId) {
    const response = await Axios().get(`desenvolvimento-biblioteca/${matriculaId}`);

    return response.data;
  }

  async salvar(payload) {
    const response = await Axios().post("desenvolvimento-biblioteca", payload);

    return response.data;
  }

  async imprimir(matriculaId) {
    return this.baixarPdf(`desenvolvimento-biblioteca/${matriculaId}/imprimir`);
  }

  async imprimirColetivo() {
    return this.baixarPdf("desenvolvimento-biblioteca/coletivo/imprimir");
  }

  async baixarPdf(url) {
    try {
      const response = await Axios().get(url, { responseType: "arraybuffer" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blob));
    } catch (err) {
      throw this.tratarErroArraybuffer(err);
    }
  }

  // Em downloads (arraybuffer), o corpo de erro vem como ArrayBuffer; decodifica para exibir a mensagem correta.
  tratarErroArraybuffer(err) {
    const buffer = err instanceof ArrayBuffer ? err : err?.response?.data;
    if (buffer instanceof ArrayBuffer) {
      try {
        const decoded = JSON.parse(new TextDecoder("utf-8").decode(buffer));
        return new Error(
          decoded.message || decoded.error?.message || "Não foi possível gerar o arquivo."
        );
      } catch (e) {
        return new Error("Não foi possível gerar o arquivo.");
      }
    }
    return err;
  }
}

export default new DesenvolvimentoBibliotecaService();
